import React from 'react';

const MobileNav = ({ isOpen, onNavigate, onClose }) => {
  const navItems = [
    { id: 'promo', label: 'Promo Videos' },
    { id: 'music', label: 'Music Videos' },
    { id: 'corporate', label: 'Corporate' },
    { id: 'film', label: 'Film Production' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' }
  ];

  const handleNavClick = (id) => {
    onNavigate(id);
    onClose();
  };

  return (
    <div className={`mobile-nav ${isOpen ? 'active' : ''}`}>
      <ul>
        {navItems.map(item => (
          <li key={item.id}>
            <a 
              href={`#${item.id}`} 
              className="nav-link"
              onClick={() => handleNavClick(item.id)}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileNav;
